/**
 * 全国态势地图 · 健康等级配色
 *
 * ⚠️ 「颜色即信息」：健康度三档必须来自 `@atlaspm/shared` 的 HEALTH_COLORS，
 *    禁止在别处硬编码，保证地图 / 星图 / 列表三处口径一致。
 *
 * shared 的 HEALTH_COLORS 只覆盖 HEALTHY / WARNING / ALERT；
 * IDLE（未启动）/ FROZEN（已冻结）两个项目态颜色取自设计令牌 tokens.css，
 * shared 暂未导出，见回执「建议补进 shared」。
 */

import { HEALTH_COLORS, type HealthLevel } from '@atlaspm/shared';

/** 项目健康等级（与后端 ProjectHealthLevel 一致） */
export type ProjectHealthLevel = HealthLevel | 'IDLE' | 'FROZEN';

export const PROJECT_LEVELS: readonly ProjectHealthLevel[] = [
  'HEALTHY',
  'WARNING',
  'ALERT',
  'IDLE',
  'FROZEN',
] as const;

export const PROJECT_LEVEL_LABELS: Readonly<Record<ProjectHealthLevel, string>> = {
  HEALTHY: '健康',
  WARNING: '预警',
  ALERT: '告警',
  IDLE: '未启动',
  FROZEN: '已冻结',
};

/** 等级 → 颜色。三档来自 shared；IDLE/FROZEN 对齐 tokens.css 的 --idle / --frozen */
export const LEVEL_COLORS: Readonly<Record<ProjectHealthLevel, string>> = {
  HEALTHY: HEALTH_COLORS.HEALTHY,
  WARNING: HEALTH_COLORS.WARNING,
  ALERT: HEALTH_COLORS.ALERT,
  IDLE: '#8fb2d0',
  FROZEN: '#a77bff',
};

export function levelColor(level: string): string {
  return LEVEL_COLORS[level as ProjectHealthLevel] ?? LEVEL_COLORS.IDLE;
}

export function levelLabel(level: string): string {
  return PROJECT_LEVEL_LABELS[level as ProjectHealthLevel] ?? level;
}
